export const defaultTheme = 'dark'

export const themeOptions = [
  { code: 'dark', label: 'Dark Mode', icon: 'moon' },
  { code: 'light', label: 'Light Mode', icon: 'sun' }
]

export function isSupportedTheme(theme) {
  return themeOptions.some((option) => option.code === theme)
}

export function getThemeOption(theme = defaultTheme) {
  const activeTheme = isSupportedTheme(theme) ? theme : defaultTheme

  return themeOptions.find((option) => option.code === activeTheme)
}
